import PropTypes from 'prop-types';
import React from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { useCarousel } from '$contexts/carousel.jsx';

import Button from './button';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @component Carousel
 * @props (see propTypes)
 */
const Carousel = ({ children, className }) => {
    const { swiperConfig } = useCarousel();

    if (!swiperConfig) { return null; }

    return (
        <Swiper
            {...swiperConfig}
            className={className}>
            {children}
        </Swiper>
    );
};

/**
 * @component CarouselPagination
 * @props (see propTypes)
 */
const CarouselPagination = ({ className }) => {
    const { swiper, totalSlides } = useCarousel();

    if (!swiper) { return null; }
    return (
        <div className={`${className ? className : ''}`}>
            {swiper.realIndex + 1}/{totalSlides}
        </div>
    );
};

/**
 * @component CarouselSlide
 * @props (see propTypes)
 */
const CarouselSlide = SwiperSlide;

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

Carousel.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string
};

CarouselPagination.propTypes = {
    className: PropTypes.string
};

CarouselSlide.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    index: PropTypes.number
};

export {
    Carousel,
    CarouselPagination,
    CarouselSlide
};

export default Carousel;
